export const ALTERAR_EMPRESA_SELECIONADA = 'ALTERAR_EMPRESA_SELECIONADA';
export const HABILITADO_PAGAMENTO_POS = 'HABILITADO_PAGAMENTO_POS';
export const BUSCAR_EMPRESAS = 'BUSCAR_EMPRESAS';
export const BUSCAR_EMPRESAS_GESTAO = 'BUSCAR_EMPRESAS_GESTAO';
export const BUSCAR_EMPRESA = 'BUSCAR_EMPRESA';
export const CADASTAR_EMPRESA = 'CADASTAR_EMPRESA';
export const ALTERAR_EMPRESA = 'ALTERAR_EMPRESA';
export const EXCLUIR_EMPRESA = 'EXCLUIR_EMPRESA';
export const BUSCAR_USUARIOS = 'BUSCAR_USUARIOS';
export const BUSCAR_USUARIOS_SISTEMA = 'BUSCAR_USUARIOS_SISTEMA'
export const BUSCAR_USUARIOS_VENDEDORES = 'BUSCAR_USUARIOS_VENDEDORES';
export const LIMPAR_USUARIOS_VENDEDORES = 'LIMPAR_USUARIOS_VENDEDORES';
export const BUSCAR_TIPOS_PERFIS = 'BUSCAR_TIPOS_PERFIS'
export const BUSCAR_MOTORISTAS = 'BUSCAR_MOTORISTAS';
export const BUSCAR_USUARIO_POR_EMAIL = 'BUSCAR_USUARIO_POR_EMAIL';
export const ALTERAR_USUARIO = 'ALTERAR_USUARIO';
export const CADASTAR_USUARIO = 'CADASTAR_USUARIO';
export const ADICIONAR_PERFIL_USUARIO = 'ADICIONAR_PERFIL_USUARIO';
export const REMOVER_PERFIL_USUARIO = 'REMOVER_PERFIL_USUARIO';
export const CADASTRAR_USUARIOS_EMPRESA_EM_LOTE = 'CADASTRAR_USUARIOS_EMPRESA_EM_LOTE';
export const LIMPAR_RETORNO_CADASTRAMENTO_USUARIO_EMPRESA_EM_LOTE = 'LIMPAR_RETORNO_CADASTRAMENTO_USUARIO_EMPRESA_EM_LOTE';
export const ADICIONAR_FILTRO_EMPRESA = 'ADICIONAR_FILTRO_EMPRESA';
export const REMOVER_FILTRO_EMPRESA = 'REMOVER_FILTRO_EMPRESA';
export const LISTAR_FILTROS_EMPRESAS = 'LISTAR_FILTROS_EMPRESAS';
export const ALTERAR_REGISTROS_POR_PAGINA_EMPRESA = 'ALTERAR_REGISTROS_POR_PAGINA_EMPRESA';
export const DETERMINAR_PAGINA_ATUAL_EMPRESA = 'DETERMINAR_PAGINA_ATUAL_EMPRESA';
export const ATIVAR_USUARIO_EMPRESA = 'ATIVAR_USUARIO_EMPRESA';
export const DESATIVAR_USUARIO_EMPRESA = 'DESATIVAR_USUARIO_EMPRESA';
export const LIMPAR_USUARIOS = 'LIMPAR_USUARIOS';
export const BUSCAR_USUARIO_POR_PARTE = 'BUSCAR_USUARIO_POR_PARTE'
export const IMPORTAR_USUARIOS_EMPRESA = 'IMPORTAR_USUARIOS_EMPRESA';
export const BUSCAR_ULTIMOS_HISTORICOS_USUARIO = 'BUSCAR_ULTIMOS_HISTORICOS_USUARIO';
export const LIMPAR_ULTIMOS_HISTORICOS_USUARIO = 'LIMPAR_ULTIMOS_HISTORICOS_USUARIO';
export const CADASTAR_DESCONTO_USUARIO_ROTA = 'CADASTAR_DESCONTO_USUARIO_ROTA';
export const BUSCAR_DESCONTO_USUARIO_ROTA = 'BUSCAR_DESCONTO_USUARIO_ROTA';
export const SELECIONAR_DESCONTO_USUARIO_ROTA = 'SELECIONAR_DESCONTO_USUARIO_ROTA';
export const EXCLUIR_DESCONTO_USUARIO_ROTA = 'EXCLUIR_DESCONTO_USUARIO_ROTA';
export const SELECIONAR_VALOR_DESCONTO_CALCULADO = 'SELECIONAR_VALOR_DESCONTO_CALCULADO';
export const ALTERAR_REGISTROS_POR_PAGINA_ROTA = 'ALTERAR_REGISTROS_POR_PAGINA_ROTA';
export const DETERMINAR_PAGINA_ATUAL_ROTA = 'DETERMINAR_PAGINA_ATUAL_ROTA';
export const DETERMINAR_PAGINA_ATUAL_ROTA_ITINERARIO = 'DETERMINAR_PAGINA_ATUAL_ROTA_ITINERARIO';
export const ALTERAR_REGISTROS_POR_PAGINA_ROTA_ITINERARIO = 'ALTERAR_REGISTROS_POR_PAGINA_ROTA_ITINERARIO';
export const REMOVER_FILTRO_ROTA = 'REMOVER_FILTRO_ROTA';
export const ADICIONAR_FILTRO_ROTA = 'ADICIONAR_FILTRO_ROTA';
export const LIMPAR_FILTRO_ROTA = 'LIMPAR_FILTRO_ROTA';
export const LISTAR_FILTROS_ROTA = 'LISTAR_FILTROS_ROTA';
export const ADICIONAR_FILTRO_ROTA_ITINERARIO = 'ADICIONAR_FILTRO_ROTA_ITINERARIO';
export const REMOVER_FILTRO_ROTA_ITINERARIO = 'REMOVER_FILTRO_ROTA_ITINERARIO';
export const LISTAR_FILTROS_ROTA_ITINERARIO = 'LISTAR_FILTROS_ROTA_ITINERARIO';
export const LIMPAR_FILTRO_ROTA_ITINERARIO = 'LIMPAR_FILTRO_ROTA_ITINERARIO';
export const BUSCAR_ITINERARIOS_FUTURO = 'BUSCAR_ITINERARIOS_FUTURO';
export const ALTERAR_ITINERARIO_FUTURO = 'ALTERAR_ITINERARIO_FUTURO';
export const BUSCAR_ULTIMOS_HISTORICOS_ITINERARIO = 'BUSCAR_ULTIMOS_HISTORICOS_ITINERARIO';
export const LIMPAR_ULTIMOS_HISTORICOS_ITINERARIO = 'LIMPAR_ULTIMOS_HISTORICOS_ITINERARIO';
export const TRANSFERIR_PASSAGEIRO = 'TRANSFERIR_PASSAGEIRO';
export const BUSCAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS = 'BUSCAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS';
export const LIMPAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS = 'LIMPAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS';

export const EXCLUIR_USUARIO = 'EXCLUIR_USUARIO';
export const DESBLOQUEAR_USUARIO = 'DESBLOQUEAR_USUARIO';
export const BLOQUEAR_USUARIO = 'BLOQUEAR_USUARIO';
export const BLOQUEAR_USUARIOS = 'BLOQUEAR_USUARIOS';
export const DESBLOQUEAR_USUARIOS = 'DESBLOQUEAR_USUARIOS';
export const ALTERAR_SENHA_USUARIO = 'ALTERAR_SENHA_USUARIO';
export const BUSCAR_TRECHOS = 'BUSCAR_TRECHOS';
export const BUSCAR_ULTIMOS_HISTORICOS_TRECHO = 'BUSCAR_ULTIMOS_HISTORICOS_TRECHO';
export const LIMPAR_ULTIMOS_HISTORICOS_TRECHO = 'LIMPAR_ULTIMOS_HISTORICOS_TRECHO';
export const ALTERAR_ORDEM_TRECHO = 'ALTERAR_ORDEM_TRECHO';
export const LIMPAR_TRECHOS = 'LIMPAR_TRECHOS';
export const CADASTRAR_TRECHO = 'CADASTRAR_TRECHO';
export const EXCLUIR_TRECHO = 'EXCLUIR_TRECHO';
export const BUSCAR_VEICULOS = 'BUSCAR_VEICULOS';
export const BUSCAR_VEICULO = 'BUSCAR_VEICULO';
export const FILTRAR_RESUMO_VEICULO = 'FILTRAR_RESUMO_VEICULO';
export const ALTERAR_DETALHAMENTO_VEICULO = 'ALTERAR_DETALHAMENTO_VEICULO';
export const BUSCAR_LOCALIZACAO_VEICULO = 'BUSCAR_LOCALIZACAO_VEICULO';

export const CADASTRAR_VEICULO = 'CADASTRAR_VEICULO';
export const EXCLUIR_VEICULO = 'EXCLUIR_VEICULO';
export const ALTERAR_VEICULO = 'ALTERAR_VEICULO';
export const SELECIONAR_VEICULO = 'SELECIONAR_VEICULO';

export const SELECIONAR_TIPOS_VEICULO = 'SELECIONAR_TIPOS_VEICULO';
export const LIMPAR_TIPOS_VEICULO = 'LIMPAR_TIPOS_VEICULO';
export const ALTERAR_MAPA_SELECIONADO_VEICULO = 'ALTERAR_MAPA_SELECIONADO_VEICULO'

export const BUSCAR_CIDADES = 'BUSCAR_CIDADES';



export const DESBLOQUEAR_AGENCIA = 'DESBLOQUEAR_AGENCIA';
export const BLOQUEAR_AGENCIA = 'BLOQUEAR_AGENCIA';


export const EXCLUIR_ROTA = 'EXCLUIR_ROTA';
export const CADASTRAR_ROTA_RETORNO = 'CADASTRAR_ROTA_RETORNO';
export const CADASTRAR_ROTA = 'CADASTRAR_ROTA';
export const BUSCAR_ROTAS = 'BUSCAR_ROTAS';
export const BUSCAR_ROTAS_IMPORTACAO = 'BUSCAR_ROTAS_IMPORTACAO';
export const IMPORTAR_ROTAS = 'IMPORTAR_ROTAS';
export const LIMPAR_ROTAS_IMPORTACAO = 'LIMPAR_ROTAS_IMPORTACAO';
export const SELECIONAR_ROTA = 'SELECIONAR_ROTA';
export const ALTERAR_DETALHAMENTO_ROTA = 'ALTERAR_DETALHAMENTO_ROTA';
export const ALTERAR_DETALHAMENTO_ROTA_ITINERARIO = 'ALTERAR_DETALHAMENTO_ROTA_ITINERARIO';
export const BUSCAR_ROTAS_ITINERARIO = 'BUSCAR_ROTAS_ITINERARIO';
export const BUSCAR_ULTIMOS_HISTORICOS_ROTA = 'BUSCAR_ULTIMOS_HISTORICOS_ROTA';
export const LIMPAR_ULTIMOS_HISTORICOS_ROTA = 'LIMPAR_ULTIMOS_HISTORICOS_ROTA';
export const CADASTRAR_CONEXAO = 'CADASTRAR_CONEXAO';
export const SELECIONAR_CONEXAO = 'SELECIONAR_CONEXAO';
export const EXCLUIR_CONEXAO = 'EXCLUIR_CONEXAO';
export const SALVAR_CIDADES_CONEXAO = 'SALVAR_CIDADES_CONEXAO';


export const BUSCAR_ITINERARIOS = 'BUSCAR_ITINERARIOS';
export const BUSCAR_RELATORIO_ITINERARIOS = 'BUSCAR_RELATORIO_ITINERARIOS';
export const FILTRAR_RELATORIO_ITINERARIOS = 'FILTRAR_RELATORIO_ITINERARIOS';
export const CADASTRAR_ITINERARIO = 'CADASTRAR_ITINERARIO';
export const CADASTRAR_ITINERARIO_POR_PERIODO = 'CADASTRAR_ITINERARIO_POR_PERIODO';
export const CADASTRAR_CUSTOS_ITINERARIO = 'CADASTRAR_CUSTOS_ITINERARIO';
export const ALTERAR_ITINERARIO = 'ALTERAR_ITINERARIO';
export const ALTERAR_VEICULO_ITINERARIO = 'ALTERAR_VEICULO_ITINERARIO';
export const EXCLUIR_ITINERARIO = 'EXCLUIR__ITINERARIOS';
export const SELECIONAR_ITINERARIO = 'SELECIONAR_ITINERARIOS';
export const SELECIONAR_ITINERARIOS = 'SELECIONAR_ITINERARIO';
export const LIMPAR_ITINERARIOS = 'LIMPAR_ITINERARIOS';
export const LIMPAR_RELATORIO_ITINERARIOS = 'LIMPAR_RELATORIO_ITINERARIOS';
export const ALTERAR_TIPO_AJUSTE_ITINERARIOS_EM_LOTE = 'ALTERAR_TIPO_AJUSTE_ITINERARIOS_EM_LOTE';
export const ALTERAR_VEICULO_ITINERARIOS_EM_LOTE = 'ALTERAR_VEICULO_ITINERARIOS_EM_LOTE';
export const ALTERAR_TIPO_PRECO_ITINERARIOS_EM_LOTE = 'ALTERAR_TIPO_PRECO_ITINERARIOS_EM_LOTE';
export const ALTERAR_PRESTADOR_ITINERARIOS_EM_LOTE = 'ALTERAR_PRESTADOR_ITINERARIOS_EM_LOTE';

export const BUSCAR_VIAGENS = 'BUSCAR_VIAGENS';
export const SELECIONAR_VIAGEM = 'SELECIONAR_VIAGEM';
export const VENDA_EM_MASSA = 'VENDA_EM_MASSA';
export const LIMPAR_VIAGENS = 'LIMPAR_VIAGENS';
export const ALTERAR_VIAGEM_SELECIONADA = 'ALTERAR_VIAGEM_SELECIONADA';

export const SELECIONAR_ORIGEM = 'SELECIONAR_ORIGEM';
export const SELECIONAR_DATA_IDA = 'SELECIONAR_DATA_IDA';

export const SELECIONAR_DESTINO = 'SELECIONAR_DESTINO';
export const SELECIONAR_DATA_VOLTA = 'SELECIONAR_DATA_VOLTA';

export const BUSCAR_PRECOS = 'BUSCAR_PRECOS';
export const RECUPERAR_VALOR_PRECO = 'RECUPERAR_VALOR_PRECO';
export const CADASTRAR_PRECO = 'CADASTRAR_PRECO';
export const IMPORTAR_PRECO = 'IMPORTAR_PRECO';
export const ALTERAR_PRECO = 'ALTERAR_PRECO';
export const EXCLUIR_PRECO = 'EXCLUIR_PRECO';
export const LIMPAR_FILTRO_PRECOS = 'LIMPAR_FILTRO_PRECOS';
export const LIMPAR_FILTROS_PRECOS_SELECIONADOS = 'LIMPAR_FILTROS_PRECOS_SELECIONADOS';
export const BUSCAR_TIPOS_PRECO = 'BUSCAR_TIPOS_PRECO';
export const BUSCAR_TIPOS_DOCUMENTOS = 'BUSCAR_TIPOS_DOCUMENTOS';
export const BUSCAR_PRECOS_ROTA = 'BUSCAR_PRECOS_ROTA';
export const BUSCAR_ULTIMOS_HISTORICOS_PRECO = 'BUSCAR_ULTIMOS_HISTORICOS_PRECO';
export const LIMPAR_ULTIMOS_HISTORICOS_PRECO = 'LIMPAR_ULTIMOS_HISTORICOS_PRECO';

export const BUSCAR_POLTRONAS = 'BUSCAR_POLTRONAS';
export const SELECIONAR_POLTRONAS = 'SELECIONAR_POLTRONAS';


export const CADASTRAR_RESERVA = 'CADASTRAR_RESERVA';
export const VERIFICAR_PAGAMENTO = 'VERIFICAR_PAGAMENTO';
export const PAGAR_FORMA_PAGAMENTO = 'PAGAR_FORMA_PAGAMENTO';
export const GERAR_LINK_PAGAMENTO_PEDIDO = 'GERAR_LINK_PAGAMENTO_PEDIDO';
export const GERAR_QRCODE_CIELO_ECOMMERCE_PEDIDO = 'GERAR_QRCODE_CIELO_ECOMMERCE_PEDIDO';
export const GERAR_QRCODE_SICOOB_PEDIDO = 'GERAR_QRCODE_SICOOB_PEDIDO';
export const CANCELAR_ENVIO_STONE_CONNECT = 'CANCELAR_ENVIO_STONE_CONNECT';
export const REMARCAR_RESERVA = 'REMARCAR_RESERVA';
export const TROCAR_POLTRONA = 'TROCAR_POLTRONA';
export const CANCELAR_RESERVAS = 'CANCELAR_RESERVAS';
export const CANCELAR_RESERVAS_COM_REEMBOLSO = 'CANCELAR_RESERVAS_COM_REEMBOLSO';
export const RESERVAS_EM_ABERTO = 'RESERVAS_EM_ABERTO';
export const RESERVAS_SOLICITADO_REEMBOLSO = 'RESERVAS_SOLICITADO_REEMBOLSO';
export const BUSCAR_RESERVAS_ITINERARIO = 'BUSCAR_RESERVAS_ITINERARIO';
export const ALTERAR_RESERVA_ITINERARIO = 'ALTERAR_RESERVA_ITINERARIO';
export const SELECIONAR_RESERVAS_TRANSFERENCIA = 'SELECIONAR_RESERVAS_TRANSFERENCIA';
export const SELECIONAR_RESERVA_REEMBOLSO_SOLICITADO = 'SELECIONAR_RESERVA_REEMBOLSO_SOLICITADO';
export const ANEXAR_DOCUMENTO_RESERVA_COM_REEMBOLSO_SOLICITADO = 'ANEXAR_DOCUMENTO_RESERVA_COM_REEMBOLSO_SOLICITADO';
export const ALTERAR_TODAS_RESERVAS_ITINERARIO = 'ALTERAR_TODAS_RESERVA_ITINERARIO';
export const BUSCAR_RESERVAS_BPE_ITINERARIO = 'BUSCAR_RESERVAS_BPE_ITINERARIO';
export const LIMPAR_RESERVAS_ITINERARIO = 'LIMPAR_RESERVAS_ITINERARIO';
export const BUSCAR_RESERVA = 'BUSCAR_RESERVA';
export const BUSCAR_DETALHAMENTO_FINANCEIRO_ITINERARIO = 'BUSCAR_DETALHAMENTO_FINANCEIRO_ITINERARIO';
export const BUSCAR_DETALHAMENTO_FINANCEIRO_ENCOMENDA = 'BUSCAR_DETALHAMENTO_FINANCEIRO_ENCOMENDA';
export const ADICIONA_REMOVE_IMAGENS_ENCOMENDA = 'ADICIONA_REMOVE_IMAGENS_ENCOMENDA';
export const SALVAR_IMAGENS_ENCOMENDA = 'SALVAR_IMAGENS_ENCOMENDA';
export const SALVAR_IMAGENS_INFORMAR_ENTREGA = 'SALVAR_IMAGENS_INFORMAR_ENTREGA';
export const EMBARCAR_ENCOMENDA = 'EMBARCAR_ENCOMENDA';
export const DESEMBARCAR_ENCOMENDA = 'DESEMBARCAR_ENCOMENDA';
export const BUSCAR_ENCOMENDA_ITINERARIO = 'BUSCAR_ENCOMENDA_ITINERARIO';
export const SALVAR_IMAGENS_EMBARQUE_ENCOMENDA = 'SALVAR_IMAGENS_EMBARQUE_ENCOMENDA';
export const SELECIONAR_RESERVA_PARA_CRIAR = 'SELECIONAR_RESERVA_PARA_CRIAR';
export const ALTERAR_PEDIDO_RESERVA_CRIADA = 'ALTERAR_PEDIDO_RESERVA_CRIADA';
export const ALTERAR_FORMA_PAGAMENTO_RESERVA_CRIADA = 'ALTERAR_FORMA_PAGAMENTO_RESERVA_CRIADA';
export const ALTERAR_SITUACAO_FORMA_PAGAMENTO_RESERVA_CRIADA = 'ALTERAR_SITUACAO_FORMA_PAGAMENTO_RESERVA_CRIADA';
export const EMBARCAR_PASSAGEIRO = 'EMBARCAR_PASSAGEIRO';
export const DESEMBARCAR_PASSAGEIRO = 'DESEMBARCAR_PASSAGEIRO';
export const NAO_EMBARCAR_PASSAGEIRO = 'NAO_EMBARCAR_PASSAGEIRO';
export const BUSCAR_MAPA_VIAGEM = 'BUSCAR_MAPA_VIAGEM';
export const CADASTRAR_REPASSE_VENDA = 'CADASTRAR_REPASSE_VENDA';
export const ALTERAR_REPASSE_VENDA = 'ALTERAR_REPASSE_VENDA';
export const SELECIONAR_REPASSE = 'SELECIONAR_REPASSE';
export const SELECIONAR_PARAMETROS_BUSCA_REPASSE = 'SELECIONAR_PARAMETROS_BUSCA_REPASSE';

export const CANCELAR_SEGURO_RESERVA = 'CANCELAR_SEGURO_RESERVA';

export const ALTERAR_COMPRADOR_IDA = 'ALTERAR_COMPRADOR_IDA';
export const ALTERAR_COMPRADOR_VOLTA = 'ALTERAR_COMPRADOR_VOLTA';
export const ADICIONAR_PASSAGEIRO = 'ADICIONAR_PASSAGEIRO';
export const ADICIONAR_PASSAGEIROS_IDA = 'ADICIONAR_PASSAGEIROS_IDA';
export const ADICIONAR_PASSAGEIROS_VOLTA = 'ADICIONAR_PASSAGEIROS_VOLTA';
export const ALTERAR_PASSAGEIRO_VOLTA = 'ALTERAR_PASSAGEIRO_VOLTA';
export const ALTERAR_TIPO_EMISSAO_PASSAGEIRO_VOLTA = 'ALTERAR_TIPO_EMISSAO_PASSAGEIRO_VOLTA'
export const ALTERAR_PASSAGEIRO_IDA = 'ALTERAR_PASSAGEIRO_IDA';
export const ALTERAR_TIPO_EMISSAO_PASSAGEIRO_IDA = 'ALTERAR_TIPO_EMISSAO_PASSAGEIRO_IDA';
export const SELECIONAR_PASSAGEIRO = 'SELECIONAR_PASSAGEIRO';
export const ADICIONAR_PASSAGEIROS = 'ADICIONAR_PASSAGEIROS'
export const ALTERAR_PASSAGEIRO = 'ALTERAR_PASSAGEIRO'

export const ADICIONAR_FILTRO_PEDIDO = 'ADICIONAR_FILTRO_PEDIDO';
export const REMOVER_FILTRO_PEDIDO = 'REMOVER_FILTRO_PEDIDO';
export const LIMPAR_FILTRO_PEDIDO = 'LIMPAR_FILTRO_PEDIDO';
export const LISTAR_FILTROS_PEDIDOS = 'LISTAR_FILTROS_PEDIDOS';

export const BUSCAR_PEDIDOS = 'BUSCAR_PEDIDOS';
export const BUSCAR_PEDIDOS_ITINEARIO = 'BUSCAR_PEDIDOS_ITINEARIO';
export const SELECIONAR_PEDIDO = 'SELECIONAR_PEDIDO';
export const ALTERAR_CRIANCA_COLO = 'ALTERAR_CRIANCA_COLO';
export const BUSCAR_PEDIDO = 'BUSCAR_PEDIDO';
export const CANCELAR_PEDIDO = 'CANCELAR_PEDIDO';
export const CANCELAR_ENCOMENDA = 'CANCELAR_ENCOMENDA';
export const ALTERAR_DETALHAMENTO_PEDIDO = 'ALTERAR_DETALHAMENTO_PEDIDO';
export const ALTERAR_FORMA_PAGAMENRO_PEDIDO = 'ALTERAR_FORMA_PAGAMENRO_PEDIDO';
export const INCLUIR_FORMA_PAGAMENTO = 'INCLUIR_FORMA_PAGAMENTO';
export const RECUPERAR_FORMA_PAGAMENTO_DESATIVADOS = 'RECUPERAR_FORMA_PAGAMENTO_DESATIVADOS';
export const RECUPERAR_PAGAMENTOS_DESATIVADOS_USUARIO = 'RECUPERAR_PAGAMENTOS_DESATIVADOS_USUARIO';
export const ALTERAR_REGISTROS_POR_PAGINA_VENDA = 'ALTERAR_REGISTROS_POR_PAGINA_VENDA';
export const DETERMINAR_PAGINA_ATUAL_VENDA = 'DETERMINAR_PAGINA_ATUAL_VENDA';
export const ALTERAR_DADOS_PASSAGEIROS = 'ALTERAR_DADOS_PASSAGEIROS';

export const MOSTRAR_LOADING = 'MOSTRAR_LOADING';
export const FECHAR_LOADING = 'FECHAR_LOADING';
export const USER_LOGOUT = '@authenticationJwtActions/USER_LOGOUT';
export const AUTHENTICATION_FAILED = '@authenticationJwtActions/AUTHENTICATION_FAILED';
export const USER_AUTHENTICATED = '@authenticationJwtActions/USER_AUTHENTICATED';
export const AUTENTICATION_TWO_FACTORY = '@authenticationJwtActions/AUTENTICATION_TWO_FACTORY';
export const REENVIAR_CODIGO_AUTENTICACAO_DOIS_FATORES = '@authenticationJwtActions/REENVIAR_CODIGO_AUTENTICACAO_DOIS_FATORES'
export const ADICIONAR_FILTRO_RETORNO = 'ADICIONAR_FILTRO_RETORNO';
export const LIMPAR_FILTRO_RETORNO = 'LIMPAR_FILTRO_RETORNO';
export const ADICIONAR_MENSAGEM_TELA = 'ADICIONAR_MENSAGEM_TELA';
export const LIMPAR_MENSAGENS_TELA = 'LIMPAR_MENSAGENS_TELA';
export const ADICIONAR_FILTRO_DATA_REJEITADA = 'ADICIONAR_FILTRO_DATA_REJEITADA';
export const LIMPAR_FILTRO_DATA_REJEITADA = 'LIMPAR_FILTRO_DATA_REJEITADA';
export const RECUPERAR_URL_PUSH = 'RECUPERAR_URL_PUSH';
export const ATUALIZAR_EMPRESAS = 'ATUALIZAR_EMPRESAS';
export const AMBIENTE_INICIADO = 'AMBIENTE_INICIADO'
export const AMBIENTE_DESCARTADO = 'AMBIENTE_DESCARTADO'

export const ADICIONAR_FILTRO_ITINERARIO = 'ADICIONAR_FILTRO_ITINERARIO';
export const REMOVER_FILTRO_ITINERARIO = 'REMOVER_FILTRO_ITINERARIO';
export const LISTAR_FILTROS_ITINERARIO = 'LISTAR_FILTROS_ITINERARIO';
export const LIMPAR_FILTRO_ITINERARIO = 'LIMPAR_FILTRO_ITINERARIO';

export const ALTERAR_REGISTROS_POR_PAGINA_PRECO = 'ALTERAR_REGISTROS_POR_PAGINA_PRECO';
export const DETERMINAR_PAGINA_ATUAL_PRECO = 'DETERMINAR_PAGINA_ATUAL_PRECO';

export const ALTERAR_REGISTROS_POR_PAGINA_ITINERARIO = 'ALTERAR_REGISTROS_POR_PAGINA_ITINERARIO';
export const DETERMINAR_PAGINA_ATUAL_ITINERARIO = 'DETERMINAR_PAGINA_ATUAL_ITINERARIO';

export const ALTERAR_REGISTROS_POR_PAGINA_RESERVA_BPE = 'ALTERAR_REGISTROS_POR_PAGINA_RESERVA_BPE';
export const DETERMINAR_PAGINA_ATUAL_RESERVA_BPE = 'DETERMINAR_PAGINA_ATUAL_RESERVA_BPE';

export const CADASTRAR_CONTROLE_EMISSAO_BPE = 'CADASTRAR_CONTROLE_EMISSAO_BPE';
export const CADASTRAR_REGRA_CONTROLE_EMISSAO_BPE = 'CADASTRAR_REGRA_CONTROLE_EMISSAO_BPE';
export const CADASTRAR_CONTROLE_EMISSAO_BPE_USUARIO = 'CADASTRAR_CONTROLE_EMISSAO_BPE_USUARIO';
export const LISTAR_CONTROLE_EMISSAO_BPE_USUARIO = 'LISTAR_CONTROLE_EMISSAO_BPE_USUARIO';
export const EXCLUIR_CONTROLE_EMISSAO_BPE_USUARIO = 'EXCLUIR_CONTROLE_EMISSAO_BPE_USUARIO';

export const ALTERAR_REGISTROS_POR_PAGINA_PEDIDO = 'ALTERAR_REGISTROS_POR_PAGINA_PEDIDO';
export const DETERMINAR_PAGINA_ATUAL_PEDIDO = 'DETERMINAR_PAGINA_ATUAL_PEDIDO';

export const SELECIONAR_PERFIS = 'SELECIONAR_PERFIS';
export const LIMPAR_PERFIS = 'LIMPAR_PERFIS';

export const LIMPAR_PRECOS = 'LIMPAR_PRECOS';

export const BUSCAR_FECHAMENTOS_CAIXA = 'BUSCAR_FECHAMENTOS_CAIXA';
export const BUSCAR_RESUMO_FINANCEIRO = 'BUSCAR_RESUMO_FINANCEIRO';
export const BUSCAR_RESUMO_FINANCEIRO_ITINERARIO = 'BUSCAR_RESUMO_FINANCEIRO_ITINERARIO';
export const LIMPAR_RESUMO_FINANCEIRO = 'LIMPAR_RESUMO_FINANCEIRO';
export const BUSCAR_FECHAMENTO_DIA = 'BUSCAR_FECHAMENTO_DIA';
export const BUSCAR_FECHAMENTO_CAIXA = 'BUSCAR_FECHAMENTO_CAIXA';
export const LIMPAR_FECHAMENTOS_CAIXA = 'LIMPAR_FECHAMENTOS_CAIXA';
export const SELECIONAR_FECHAMENTO_CAIXA = 'SELECIONAR_FECHAMENTO_CAIXA';
export const ENVIAR_FECHAMENTO_CAIXA = 'ENVIAR_FECHAMENTO_CAIXA';
export const SALVAR_FECHAMENTO_CAIXA = 'SALVAR_FECHAMENTO_CAIXA';
export const APROVAR_FECHAMENTO_CAIXA = 'APROVAR_FECHAMENTO_CAIXA';
export const DEVOLVER_FECHAMENTO_CAIXA = 'DEVOLVER_FECHAMENTO_CAIXA';
export const GERAR_PIX_FECHAMENTO_CAIXA = 'GERAR_PIX_FECHAMENTO_CAIXA';
export const VERIFICAR_PAGAMENTO_PIX_FECHAMENTO_CAIXA = 'VERIFICAR_PAGAMENTO_PIX_FECHAMENTO_CAIXA';
export const GERAR_PIX_FECHAMENTO_CAIXA_SICOOB = 'GERAR_PIX_FECHAMENTO_CAIXA_SICOOB';
export const VERIFICAR_PAGAMENTO_PIX_FECHAMENTO_CAIXA_SICOOB = 'VERIFICAR_PAGAMENTO_PIX_FECHAMENTO_CAIXA_SICOOB';
export const ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA = 'ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA';
export const ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA_DIA = 'ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA_DIA';
export const EXPORTAR_FECHAMENTOS_CAIXA = 'EXPORTAR_FECHAMENTOS_CAIXA';

export const BUSCAR_CAIXA_ABERTO = 'BUSCAR_CAIXA_ABERTO';

export const ALTERAR_REGISTROS_POR_PAGINA_CIDADE = 'ALTERAR_REGISTROS_POR_PAGINA_CIDADE';
export const DETERMINAR_PAGINA_ATUAL_CIDADE = 'DETERMINAR_PAGINA_ATUAL_CIDADE';
export const CADASTRAR_CIDADE = 'CADASTRAR_CIDADE';
export const ALTERAR_CIDADE = 'ALTERAR_CIDADE';
export const EXCLUIR_CIDADE = 'EXCLUIR_CIDADE';
export const SELECIONAR_CIDADE = 'SELECIONAR_CIDADE';
export const LIMPAR_CIDADE_SELECIONADA = 'LIMPAR_CIDADE_SELECIONADA';


export const CRIAR_MAPA_VEICULO = 'CRIAR_MAPA_VEICULO';
export const BUSCAR_MAPAS_VEICULOS = 'BUSCAR_MAPAS_VEICULOS';
export const ALTERAR_REGISTROS_POR_PAGINA_MAPAS_VEICULOS = 'ALTERAR_REGISTROS_POR_PAGINA_MAPAS_VEICULOS';
export const DETERMINAR_PAGINA_ATUAL_MAPAS_VEICULOS = 'DETERMINAR_PAGINA_ATUAL_MAPAS_VEICULOS';
export const SELECIONAR_MAPA_VEICULO = 'SELECIONAR_MAPA_VEICULO';
export const LIMPAR_MAPA_VEICULO = 'LIMPAR_MAPA_VEICULO';
export const BUSCAR_MAPA_ITINERARIO_IDA = 'BUSCAR_MAPA_ITINERARIO_IDA';
export const LIMPAR_MAPA_ITINERARIO_IDA = 'LIMPAR_MAPA_ITINERARIO_IDA';
export const BUSCAR_MAPA_ITINERARIO_VOLTA = 'BUSCAR_MAPA_ITINERARIO_VOLTA';
export const LIMPAR_MAPA_ITINERARIO_VOLTA = 'LIMPAR_MAPA_ITINERARIO_VOLTA';
export const SELECIONAR_ASSENTO_ITINERARIO_IDA = 'SELECIONAR_ASSENTO_ITINERARIO_IDA';
export const SELECIONAR_ASSENTO_ITINERARIO_VOLTA = 'SELECIONAR_ASSENTO_ITINERARIO_VOLTA';
export const ALTERAR_REGISTROS_POR_PAGINA_VEICULO = 'ALTERAR_REGISTROS_POR_PAGINA_VEICULO';
export const DETERMINAR_PAGINA_ATUAL_VEICULO = 'DETERMINAR_PAGINA_ATUAL_VEICULO';
export const EXCLUIR_MAPA_VEICULO = 'EXCLUIR_MAPA_VEICULO';
export const ADICIONAR_FILTRO_MAPA_VEICULO = 'ADICIONAR_FILTRO_MAPA_VEICULO';
export const BUSCAR_PESSOA_REMETENTE = 'BUSCAR_PESSOA_REMETENTE';
export const BUSCAR_PESSOA = 'BUSCAR_PESSOA';
export const BUSCAR_PESSOA_DESTINATARIO = 'BUSCAR_PESSOA_DESTINATARIO';
export const SELECIONAR_PESSOA_DESTINATARIO = 'SELECIONAR_PESSOA_DESTINATARIO';
export const SELECIONAR_PESSOA_REMETENTE = 'SELECIONAR_PESSOA_REMETENTE';
export const SELECIONAR_ENDERECO_REMETENTE = 'SELECIONAR_ENDERECO_REMETENTE';
export const SELECIONAR_ENDERECO_DESTINATARIO = 'SELECIONAR_ENDERECO_DESTINATARIO';
export const BUSCAR_ENDERECO_POR_CEP = 'BUSCAR_ENDERECO_POR_CEP';
export const SELECIONAR_ENDERECO = 'SELECIONAR_ENDERECO';
export const CADASTRAR_ENDERECO = 'CADASTRAR_ENDERECO';
export const CADASTRAR_PESSOA = 'CADASTRAR_PESSOA';
export const ATUALIZAR_PESSOA = 'ATUALIZAR_PESSOA';
export const ADICIONAR_NOTA_FISCAL = 'ADICIONAR_NOTA_FISCAL';
export const REMOVER_NOTA_FISCAL = 'REMOVER_NOTA_FISCAL';
export const ADICIONAR_DADOS_PAGAMENTO_ENCOMENDA = 'ADICIONAR_DADOS_PAGAMENTO_ENCOMENDA';
export const ADICIONAR_FORMAS_PAGAMENTO_ENCOMENDA = 'ADICIONAR_FORMAS_PAGAMENTO_ENCOMENDA';
export const CADASTRAR_CONFIGURACAO_ENCOMENDA = 'CADASTRAR_CONFIGURACAO_ENCOMENDA';
export const BUSCAR_CONFIGURACAO_ENCOMENDA = 'BUSCAR_CONFIGURACAO_ENCOMENDA';
export const CADASTRAR_CONFIGURACAO_EXCESSO_BAGAGEM = 'CADASTRAR_CONFIGURACAO_EXCESSO_BAGAGEM';
export const BUSCAR_CONFIGURACAO_EXCESSO_BAGAGEM = 'BUSCAR_CONFIGURACAO_EXCESSO_BAGAGEM';
export const CADASTRAR_ENCOMENDA = 'CADASTRAR_ENCOMENDA';
export const LIMPAR_DADOS_PAGAMENTO_ENCOMENDA = 'LIMPAR_DADOS_PAGAMENTO_ENCOMENDA';
export const BUSCAR_ENCOMENDA = 'BUSCAR_ENCOMENDA';
export const BUSCAR_ENCOMENDAS = 'BUSCAR_ENCOMENDAS';
export const SELECIONAR_ENCOMENDA = 'SELECIONAR_ENCOMENDA';
export const ALTERAR_DETALHAMENTO_ENCOMENDA = 'ALTERAR_DETALHAMENTO_ENCOMENDA';
export const BUSCAR_MAPA_VEICULO_ITINERARIO = 'BUSCAR_MAPA_VEICULO_ITINERARIO';
export const SELECIONAR_MAPA_VEICULO_ITINERARIO = 'SELECIONAR_MAPA_VEICULO_ITINERARIO';
export const BUSCAR_ITINERARIO = 'BUSCAR_ITINERARIO';
export const BLOQUEAR_POLTRONA = 'BLOQUEAR_POLTRONA';
export const DESBLOQUEAR_POLTRONA = 'DESBLOQUEAR_POLTRONA';
export const ALTERAR_REGISTROS_POR_PAGINA_USUARIO = 'ALTERAR_REGISTROS_POR_PAGINA_USUARIO';
export const DETERMINAR_PAGINA_ATUAL_USUARIO = 'DETERMINAR_PAGINA_ATUAL_USUARIO';
export const BUSCAR_AGENCIAS = 'BUSCAR_AGENCIAS';
export const EXCLUIR_AGENCIAS = 'EXCLUIR_AGENCIAS';
export const CADASTRAR_AGENCIAS = 'CADASTRAR_AGENCIAS';
export const ALTERAR_AGENCIAS = 'ALTERAR_AGENCIAS';
export const SELECIONAR_AGENCIA = 'SELECIONAR_AGENCIA';
export const ALTERAR_DETALHAMENTO_AGENCIA = 'ALTERAR_DETALHAMENTO_AGENCIA';
export const LIMPA_SELECIONAR_BILHETE = 'LIMPA_SELECIONAR_BILHETE';

export const SELECIONAR_USUARIO = 'SELECIONAR_USUARIO';

export const SELECIONAR_BILHETE = 'SELECIONAR_BILHETE'

export const SELECIONAR_VIAGEM_IDA = 'SELECIONAR_VIAGEM_IDA';
export const SELECIONAR_VIAGEM_VOLTA = 'SELECIONAR_VIAGEM_VOLTA';

export const ADICIONAR_FORMAS_PAGAMENTO = 'ADICIONAR_FORMAS_PAGAMENTO';
export const ALTERAR_SITUACAO_PAGAMENTO = 'ALTERAR_SITUACAO_PAGAMENTO';
export const ADICIONAR_DADOS_PAGAMENTO  = 'ADICIONAR_DADOS_PAGAMENTO';

export const BUSCAR_OPCAO_DESCONTO_MEIA_PASSAGEM = 'BUSCAR_OPCAO_DESCONTO_MEIA_PASSAGEM';

export const BUSCAR_PASSAGEIRO_POR_CPF = 'BUSCAR_PASSAGEIRO_POR_CPF';

export const POLTRONA_GRATUITA_DISPONIVEL = 'POLTRONA_GRATUITA_DISPONIVEL'

export const   VENDA_SEGURO_HABILITADA = 'VENDA_SEGURO_HABILITADA';

export const ALTERAR_REGISTROS_POR_PAGINA_FECHAMENTO_CAIXA = 'ALTERAR_REGISTROS_POR_PAGINA_FECHAMENTO_CAIXA';
export const DETERMINAR_PAGINA_ATUAL_FECHAMENTO_CAIXA = 'DETERMINAR_PAGINA_ATUAL_FECHAMENTO_CAIXA';

export const ADICIONAR_FILTRO_FECHAMENTO_CAIXA = 'ADICIONAR_FILTRO_FECHAMENTO_CAIXA';
export const REMOVER_FILTRO_FECHAMENTO_CAIXA = 'REMOVER_FILTRO_FECHAMENTO_CAIXA';
export const LIMPAR_FILTRO_FECHAMENTO_CAIXA = 'LIMPAR_FILTRO_FECHAMENTO_CAIXA';
export const LISTAR_FILTROS_FECHAMENTO_CAIXA = 'LISTAR_FILTROS_FECHAMENTO_CAIXA';

export const BUSCAR_RESERVAS_REMARCACAO = 'BUSCAR_RESERVAS_REMARCACAO';
export const ALTERAR_MARCACAO_RESERVA = 'ALTERAR_MARCACAO_RESERVA';
export const LIMPAR_RESERVAS_MARCACAO = 'LIMPAR_RESERVAS_MARCACAO';
export const SELECIONAR_RESERVAS_MARCACAO = 'SELECIONAR_RESERVAS_MARCACAO';

export const BUSCAR_RESERVAS_EXCESSO_BAGAGEM = 'BUSCAR_RESERVAS_EXCESSO_BAGAGEM'
export const ALTERAR_MARCACAO_RESERVA_EXCESSO_BAGAGEM = 'ALTERAR_MARCACAO_RESERVA_EXCESSO_BAGAGEM';
export const LIMPAR_RESERVAS_MARCACAO_EXCESSO_BAGAGEM = 'LIMPAR_RESERVAS_MARCACAO_EXCESSO_BAGAGEM';
export const SELECIONAR_RESERVAS_MARCACAO_EXCESSO_BAGAGEM = 'SELECIONAR_RESERVAS_MARCACAO_EXCESSO_BAGAGEM';

export const ALTERAR_REGISTROS_POR_PAGINA_ENCOMENDA = 'ALTERAR_REGISTROS_POR_PAGINA_ENCOMENDA';
export const DETERMINAR_PAGINA_ATUAL_ENCOMENDA = 'DETERMINAR_PAGINA_ATUAL_ENCOMENDA';

export const ADICIONAR_FILTRO_ENCOMENDA = 'ADICIONAR_FILTRO_ENCOMENDA';
export const REMOVER_FILTRO_ENCOMENDA = 'REMOVER_FILTRO_ENCOMENDA';
export const LIMPAR_FILTRO_ENCOMENDA = 'LIMPAR_FILTRO_ENCOMENDA';
export const LISTAR_FILTROS_ENCOMENDA = 'LISTAR_FILTROS_ENCOMENDA';

export const SELECIONAR_TIPOS_EMISSOES = 'SELECIONAR_TIPOS_EMISSOES';
export const CALCULAR_DESCONTO_USUARIO = 'CALCULAR_DESCONTO_USUARIO';

export const ADICIONAR_FILTRO_USUARIO = 'ADICIONAR_FILTRO_USUARIO';
export const REMOVER_FILTRO_USUARIO = 'REMOVER_FILTRO_USUARIO';
export const LIMPAR_FILTRO_USUARIO = 'LIMPAR_FILTRO_USUARIO';
export const LISTAR_FILTROS_USUARIO = 'LISTAR_FILTROS_USUARIO';

//Filtro de Agencia e Componente de Paginacao
export const ADICIONAR_FILTRO_AGENCIA = 'ADICIONAR_FILTRO_AGENCIA';
export const REMOVER_FILTRO_AGENCIA = 'REMOVER_FILTRO_AGENCIA';
export const LISTAR_FILTROS_AGENCIA = 'LISTAR_FILTROS_AGENCIA';
export const ALTERAR_REGISTROS_POR_PAGINA_AGENCIA = 'ALTERAR_REGISTROS_POR_PAGINA_AGENCIA';
export const DETERMINAR_PAGINA_ATUAL_AGENCIA = 'DETERMINAR_PAGINA_ATUAL_AGENCIA';

export const ADICIONAR_FILTRO_PRESTADOR = 'ADICIONAR_FILTRO_PRESTADOR';
export const REMOVER_FILTRO_PRESTADOR = 'REMOVER_FILTRO_PRESTADOR';
export const ALTERAR_REGISTROS_POR_PAGINA_PRESTADOR = 'ALTERAR_REGISTROS_POR_PAGINA_PRESTADOR';
export const DETERMINAR_PAGINA_ATUAL_PRESTADOR = 'DETERMINAR_PAGINA_ATUAL_PRESTADOR';
export const ALTERAR_PRESTADOR = 'ALTERAR_PRESTADOR';
export const BUSCAR_PRESTADORES = 'BUSCAR_PRESTADORES';
export const CADASTRAR_PRESTADOR = 'CADASTRAR_PRESTADOR';
export const EXCLUIR_PRESTADOR = 'EXCLUIR_PRESTADOR';
export const SELECIONAR_PRESTADOR = 'SELECIONAR_PRESTADOR';
export const BUSCAR_PRESTADORES_SIMPLES = 'BUSCAR_PRESTADORES_SIMPLES';

export const BUSCAR_REGRA_BILHETE = 'BUSCAR_REGRA_BILHETE';


export const BUSCAR_IMPOSTOS = 'BUSCAR_IMPOSTOS';
export const BUSCAR_PLATAFORMAS = 'BUSCAR_PLATAFORMAS';
export const BUSCAR_GRUPOS = 'BUSCAR_GRUPOS';

export const BUSCAR_IMPOSTOS_EMPRESA = 'BUSCAR_IMPOSTOS_EMPRESA';
export const CADASTRAR_IMPOSTO_EMPRESA = 'CADASTRAR_IMPOSTO_EMPRESA';
export const ALTERAR_IMPOSTO_EMPRESA = 'ALTERAR_IMPOSTO_EMPRESA';
export const EXCLUIR_IMPOSTO_EMPRESA = 'EXCLUIR_IMPOSTO_EMPRESA';

export const CADASTRAR_USUARIO_EMPRESA_AGENCIA = 'CADASTRAR_USUARIO_EMPRESA_AGENCIA';
export const EXCLUIR_USUARIO_EMPRESA_AGENCIA = 'EXCLUIR_USUARIO_EMPRESA_AGENCIA';
export const BUSCAR_USUARIOS_EMPRESA_AGENCIA = 'BUSCAR_USUARIOS_EMPRESA_AGENCIA';

export const DETERMINAR_PAGINA_ATUAL_SELECAO_EMPRESA = 'DETERMINAR_PAGINA_ATUAL_SELECAO_EMPRESA';
export const ALTERAR_NUMERO_REGISTROS_POR_PAGINA_SELECAO_EMPRESA = 'ALTERAR_NUMERO_REGISTROS_POR_PAGINA_SELECAO_EMPRESA'
export const FILTRAR_SELECAO_EMPRESA = 'FILTRAR_SELECAO_EMPRESA';
export const LIMPAR_FILTRO_SELECAO_EMPRESA = 'LIMPAR_FILTRO_SELECAO_EMPRESA';

export const DESBLOQUEAR_EMPRESA = 'DESBLOQUEAR_EMPRESA';
export const BLOQUEAR_EMPRESA = 'BLOQUEAR_EMPRESA';

export const DETERMINAR_PAGINA_ATUAL_RESUMO_FINANCEIRO = 'DETERMINAR_PAGINA_ATUAL_RESUMO_FINANCEIRO';
export const ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RESUMO_FINANCEIRO = 'ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RESUMO_FINANCEIRO'

export const DETERMINAR_PAGINA_ATUAL_RELATORIO_ITINERARIOS = 'DETERMINAR_PAGINA_ATUAL_RELATORIO_ITINERARIOS';
export const ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RELATORIO_ITINERARIOS = 'ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RELATORIO_ITINERARIOS'


export const ATIVAR_USUARIO_PLATAFORMA_WEB = 'ATIVAR_USUARIO_PLATAFORMA_WEB';
export const DESATIVAR_USUARIO_PLATAFORMA_WEB = 'DESATIVAR_USUARIO_PLATAFORMA_WEB';
export const RESETAR_SENHA_USUARIO_PLATAFORMA_WEB = 'RESETAR_SENHA_USUARIO_PLATAFORMA_WEB';

export const FILTRAR_RESUMO_FINANCEIRO = 'FILTRAR_RESUMO_FINANCEIRO';

export const ADICIONAR_FILTRO_CUPOM = 'ADICIONAR_FILTRO_CUPOM';
export const REMOVER_FILTRO_CUPOM = 'REMOVER_FILTRO_CUPOM';
export const LISTAR_FILTROS_CUPOM = 'LISTAR_FILTROS_CUPOM';

export const ADICIONAR_FILTRO_BAGAGEM = 'ADICIONAR_FILTRO_BAGAGEM';
export const REMOVER_FILTRO_BAGAGEM = 'REMOVER_FILTRO_BAGAGEM';
export const LISTAR_FILTROS_BAGAGEM = 'LISTAR_FILTROS_BAGAGEM';
export const DETERMINAR_PAGINA_ATUAL_BAGAGEM = 'DETERMINAR_PAGINA_ATUAL_BAGAGEM';
export const ALTERAR_REGISTROS_POR_PAGINA_BAGAGEM = 'ALTERAR_REGISTROS_POR_PAGINA_BAGAGEM';


export const ATIVAR_VENDAS_SITE = 'ATIVAR_VENDAS_SITE';
export const INATIVAR_VENDAS_SITE = 'INATIVAR_VENDAS_SITE';
export const ATIVAR_HORARIO_EXTRA = 'ATIVAR_HORARIO_EXTRA';
export const INATIVAR_HORARIO_EXTRA = 'INATIVAR_HORARIO_EXTRA';
export const HABILITAR_VENDAS_EM_LOTE_NO_SITE = 'HABILITAR_VENDAS_EM_LOTE_NO_SITE';

export const ATIVAR_ITINERARIO = 'ATIVAR_ITINERARIO';
export const INATIVAR_ITINERARIO = 'INATIVAR_ITINERARIO';
export const VERIFICAR_ITINERARIO_ATIVO_OU_INATIVO = 'VERIFICAR_ITINERARIO_ATIVO_OU_INATIVO';
export const VERIFICAR_VINCULO_ITINERARIO_e_MOTORISTA= 'VERIFICAR_VINCULO_ITINERARIO_e_MOTORISTA';

export const ATIVAR_ITINERARIO_EM_LOTE = 'ATIVAR_ITINERARIO_EM_LOTE';
export const INATIVAR_ITINERARIO_EM_LOTE = 'INATIVAR_ITINERARIO_EM_LOTE';

export const LIMPAR_RESULTADO_ATIVACAO_ITINERARIO_EM_LOTE = 'LIMPAR_RESULTADO_ATIVACAO_ITINERARIO_EM_LOTE';

export const BLOQUEAR_ITINERARIO_POR_CIDADE_EM_LOTE = 'BLOQUEAR_ITINERARIO_POR_CIDADE_EM_LOTE';

export const BLOQUEAR_VENDA_USUARIO_EMPRESA_ITINERARIO_EM_LOTE = 'BLOQUEAR_VENDA_USUARIO_EMPRESA_ITINERARIO_EM_LOTE';

export const BUSCAR_CUSTO_ITINERARIO = 'BUSCAR_CUSTO_ITINERARIO';

export const BLOQUEAR_POLTRONA_JA_MARCADO_ITINERARIO_IDA = 'BLOQUEAR_POLTRONA_JA_MARCADO_ITINERARIO_IDA';

export const BLOQUEAR_POLTRONA_JA_MARCADO_ITINEARARIO_VOLTA = 'BLOQUEAR_POLTRONA_JA_MARCADO_ITINEARARIO_VOLTA';


export const BUSCAR_DADOS_VEXADO_BI = 'BUSCAR_DADOS_VEXADO_BI';
export const LIMPAR_DADOS_VEXADO_BI = 'LIMPAR_DADOS_VEXADO_BI';

export const BUSCAR_REPASSE_VENDA_SITE = 'BUSCAR_REPASSE_VENDA_SITE';
export const LIMPAR_REPASSE_VENDA_SITE = 'LIMPAR_REPASSE_VENDA_SITE';

export const BUSCAR_BI_VENDEDOR = 'BUSCAR_BI_VENDEDOR';
export const LIMPAR_BI_VENDEDOR = 'LIMPAR_BI_VENDEDOR';

export const BUSCAR_RESERVAS_REPASSE = 'BUSCAR_RESERVAS_REPASSE';

export const SELECIONAR_VEICULO_ITINERARIO = 'SELECIONAR_VEICULO_ITINERARIO';
export const LIMPAR_VEICULO_ITINERARIO_SELECIONADO = 'LIMPAR_VEICULO_ITINERARIO_SELECIONADO';

export const ADICIONAR_FILTRO_ITINERARIO_EMBARQUE = 'ADICIONAR_FILTRO_ITINERARIO_EMBARQUE';
export const REMOVER_FILTRO_ITINERARIO_EMBARQUE = 'REMOVER_FILTRO_ITINERARIO_EMBARQUE';
export const LISTAR_FILTROS_ITINERARIO_EMBARQUE = 'LISTAR_FILTROS_ITINERARIO_EMBARQUE';
export const LIMPAR_FILTRO_ITINERARIO_EMBARQUE = 'LIMPAR_FILTRO_ITINERARIO_EMBARQUE';
export const DETERMINAR_PAGINA_ATUAL_ITINERARIO_EMBARQUE = 'DETERMINAR_PAGINA_ATUAL_ITINERARIO_EMBARQUE';
export const ALTERAR_REGISTROS_POR_PAGINA_ITINERARIO_EMBARQUE = 'ALTERAR_REGISTROS_POR_PAGINA_ITINERARIO_EMBARQUE';

export const BUSCAR_AGRUPADOS_DISPONIBILIDADES_VEICULO = 'BUSCAR_AGRUPADOS_DISPONIBILIDADES_VEICULO';
export const BUSCAR_AGRUPADO_DISPONIBILIDADES_VEICULO = 'BUSCAR_AGRUPADO_DISPONIBILIDADES_VEICULO';
export const SELECIONAR_AGRUPADO_DISPONIBILIDADE_VEICULO ='SELECIONAR_AGRUPADO_DISPONIBILIDADE_VEICULO';
export const CADASTRAR_DISPONIBILIDADE_VEICULO = 'CADASTRAR_DISPONIBILIDADE_VEICULO';
export const BUSCAR_DISPONIBILIDADES_VEICULO = 'BUSCAR_DISPONIBILIDADES_VEICULO';
export const LIMPAR_DISPONIBILIDADES_VEICULO = 'LIMPAR_DISPONIBILIDADES_VEICULO';
export const SELECIONAR_DISPONIBILIDADE_VEICULO = 'SELECIONAR_DISPONIBILIDADE_VEICULO';
export const EXCLUIR_DISPONIBILIDADE_VEICULO = 'EXCLUIR_DISPONIBILIDADE_VEICULO';

export const BUSCAR_PESSOA_CONTRATANTE = 'BUSCAR_PESSOA_CONTRATANTE';
export const SELECIONAR_PESSOA_CONTRATANTE='SELECIONAR_PESSOA_CONTRATANTE';
export const BUSCAR_VEICULOS_DISPONIVEIS='BUSCAR_VEICULOS_DISPONIVEIS';
export const LIMPAR_VEICULOS_DISPONIVEIS='LIMPAR_VEICULOS_DISPONIVEIS';
export const CADASTRAR_AGENDAMENTO_VIAGEM = 'CADASTRAR_AGENDAMENTO_VIAGEM';
export const BUSCAR_AGENDAMENTOS_VIAGENS = 'BUSCAR_AGENDAMENTOS_VIAGENS';
export const LIMPAR_AGENDAMENTOS_VIAGENS = 'LIMPAR_AGENDAMENTOS_VIAGENS';
export const SELECIONAR_AGENDAMENTO_VIAGEM = 'SELECIONAR_AGENDAMENTO_VIAGEM';

export const BUSCAR_TOMADORES = 'BUSCAR_TOMADORES';
export const CADASTRAR_TOMADOR = 'CADASTRAR_TOMADOR';
export const ALTERAR_TOMADOR = 'ALTERAR_TOMADOR';
export const DETERMINAR_PAGINA_ATUAL_TOMADORES = 'DETERMINAR_PAGINA_ATUAL_TOMADORES';
export const ALTERAR_REGISTROS_POR_PAGINA_TOMADORES = 'ALTERAR_REGISTROS_POR_PAGINA_TOMADORES';
export const ADICIONAR_FILTRO_TOMADOR = 'ADICIONAR_FILTRO_TOMADOR';
export const REMOVER_FILTRO_TOMADOR = 'REMOVER_FILTRO_TOMADOR';

export const BUSCAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM = 'BUSCAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM';
export const SELECIONAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM = 'SELECIONAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM';
export const BUSCAR_AGENDAMENTO_VIAGEM = 'BUSCAR_AGENDAMENTO_VIAGEM';
export const CADASTRAR_AGENDAMENTO_VIAGEM_PASSAGEIRO = 'CADASTRAR_AGENDAMENTO_VIAGEM_PASSAGEIRO';
export const EXCLUIR_AGENDAMENTO_VIAGEM_PASSAGEIRO = 'EXCLUIR_AGENDAMENTO_VIAGEM_PASSAGEIRO';
export const LIMPAR_SELECAO_MAPA_VEICULO_AGENDAMENTO_VIAGEM = 'LIMPAR_SELECAO_MAPA_VEICULO_AGENDAMENTO_VIAGEM';

export const CADASTRAR_EMISSAO_CTE_OS = 'CADASTRAR_EMISSAO_CTE_OS';
export const BUSCAR_EMISSOES_CTE_OS = 'BUSCAR_EMISSOES_CTE_OS';
export const BUSCAR_TODOS_TOMADORES = 'BUSCAR_TODOS_TOMADORES';
export const SELECIONAR_EMISSAO_CTE_OS = 'SELECIONAR_EMISSAO_CTE_OS';
export const BUSCAR_OPCOES_FILTROS_EMISSOES_CTE_OS = 'BUSCAR_OPCOES_FILTROS_EMISSOES_CTE_OS';
export const TRANSMITIR_EMISSAO_CTE_OS = 'TRANSMITIR_EMISSAO_CTE_OS';
export const BUSCAR_EMISSAO_CTE_OS_NOTA_FISCAL = 'BUSCAR_EMISSAO_CTE_OS_NOTA_FISCAL';
export const ALTERAR_REGISTROS_POR_PAGINA_CTE_OS = 'ALTERAR_REGISTROS_POR_PAGINA_CTE_OS';
export const DETERMINAR_PAGINA_ATUAL_CTE_OS = 'DETERMINAR_PAGINA_ATUAL_CTE_OS';

export const ADICIONAR_FILTRO_CTE_OS = 'ADICIONAR_FILTRO_CTE_OS';
export const LIMPAR_FILTRO_CTE_OS = 'LIMPAR_FILTRO_CTE_OS';
export const LISTAR_FILTROS_CTE_OS = 'LISTAR_FILTROS_CTE_OS';
export const REMOVER_FILTRO_CTE_OS = 'REMOVER_FILTRO_CTE_OS';
export const CANCELAR_CTE_OS = 'CANCELAR_CTE_OS';

export const CADASTRAR_EMISSAO_MDFE = 'CADASTRAR_EMISSAO_MDFE';
export const BUSCAR_EMISSOES_MDFE = 'BUSCAR_EMISSOES_MDFE';
export const SELECIONAR_EMISSAO_MDFE = 'SELECIONAR_EMISSAO_MDFE';
export const BUSCAR_OPCOES_FILTROS_EMISSOES_MDFE = 'BUSCAR_OPCOES_FILTROS_EMISSOES_MDFE';
export const TRANSMITIR_EMISSAO_MDFE = 'TRANSMITIR_EMISSAO_MDFE';
export const CANCELAR_MDFE = 'CANCELAR_MDFE';
export const ENCERRAR_MDFE = 'ENCERRAR_MDFE';
export const ALTERAR_REGISTROS_POR_PAGINA_MDFE = 'ALTERAR_REGISTROS_POR_PAGINA_MDFE';
export const DETERMINAR_PAGINA_ATUAL_MDFE = 'DETERMINAR_PAGINA_ATUAL_MDFE';
export const ADICIONAR_FILTRO_MDFE = 'ADICIONAR_FILTRO_MDFE';
export const LIMPAR_FILTRO_MDFE = 'LIMPAR_FILTRO_MDFE';
export const LISTAR_FILTROS_MDFE = 'LISTAR_FILTROS_MDFE';
export const REMOVER_FILTRO_MDFE = 'REMOVER_FILTRO_MDFE';
export const BUSCAR_CTES_DISPONIVEIS_MDFE = 'BUSCAR_CTES_DISPONIVEIS_MDFE';
export const BUSCAR_DAMDFE = 'BUSCAR_DAMDFE';

export const BUSCAR_OPCOES_FILTROS_EMISSOES_CTE = 'BUSCAR_OPCOES_FILTROS_EMISSOES_CTE';
export const BUSCAR_SE_USUARIO_VENDE_ENCOMENDA_COM_CTE = 'BUSCAR_SE_USUARIO_VENDE_ENCOMENDA_COM_CTE';
export const ADICIONAR_DADOS_CTE_ENCOMENDA = 'ADICIONAR_DADOS_CTE_ENCOMENDA';
export const LIMPAR_DADOS_CTE_ENCOMENDA = 'LIMPAR_DADOS_CTE_ENCOMENDA';
export const TRANSMITIR_EMISSAO_CTE = 'TRANSMITIR_EMISSAO_CTE';

export const BUSCAR_OPEN_GRAPH = 'BUSCAR_OPEN_GRAPH';

export const SELECIONAR_VALOR_ACRESCIMO_PASSAGEM_CALCULADO = 'SELECIONAR_VALOR_ACRESCIMO_PASSAGEM_CALCULADO';
export const SELECIONAR_ACRESCIMO_PASSAGEM_USUARIO = 'SELECIONAR_ACRESCIMO_PASSAGEM_USUARIO';

export const CALCULAR_ACRESCIMO_PASSAGEM_USUARIO = 'CALCULAR_ACRESCIMO_PASSAGEM_USUARIO';

export const CADASTRAR_REGITRO_MANUTENCAO_VEICULO = 'CADASTRAR_REGITRO_MANUTENCAO_VEICULO';
export const BUSCAR_MANUTENCOES_VEICULO = 'BUSCAR_MANUTENCOES_VEICULO';
export const SELECIONAR_MANUTENCAO_VEICULO = 'SELECIONAR_MANUTENCAO_VEICULO';
export const ATUALIZAR_REGITRO_MANUTENCAO_VEICULO = 'ATUALIZAR_REGITRO_MANUTENCAO_VEICULO';
export const EXCLUIR_MANUTENCAO_VEICULO = 'EXCLUIR_MANUTENCAO_VEICULO';
export const ALTERAR_DETALHAMENTO_MANUTENCAO_VEICULO = 'ALTERAR_DETALHAMENTO_MANUTENCAO_VEICULO';
export const ADICIONAR_FILTRO_MANUTENCAO_VEICULO = 'ADICIONAR_FILTRO_MANUTENCAO_VEICULO';
export const REMOVER_FILTRO_MANUTENCAO_VEICULO = 'REMOVER_FILTRO_MANUTENCAO_VEICULO';
export const LIMPAR_FILTRO_MANUTENCAO_VEICULO = 'LIMPAR_FILTRO_MANUTENCAO_VEICULO';


export const ADICIONAR_FILTRO_CENTRO_CUSTO = 'ADICIONAR_FILTRO_CENTRO_CUSTO';
export const REMOVER_FILTRO_CENTRO_CUSTO = 'REMOVER_FILTRO_CENTRO_CUSTO';
export const LIMPAR_FILTRO_CENTRO_CUSTO = 'LIMPAR_FILTRO_CENTRO_CUSTO';
export const DETERMINAR_PAGINA_ATUAL_CENTRO_CUSTO = 'DETERMINAR_PAGINA_ATUAL_CENTRO_CUSTO';
export const ALTERAR_REGISTROS_POR_PAGINA_CENTRO_CUSTO = 'ALTERAR_REGISTROS_POR_PAGINA_CENTRO_CUSTO';

export const BUSCAR_OPCOES_FILTROS_CONFIGURACAO_BILHETE = 'BUSCAR_OPCOES_FILTROS_CONFIGURACAO_BILHETE';
export const ALTERAR_DETALHAMENTO_CONFIGURACAO_BILHETE = 'ALTERAR_DETALHAMENTO_CONFIGURACAO_BILHETE';

export const NOTIFICAR_ENTREGA_ENCOMENDA = 'NOTIFICAR_ENTREGA_ENCOMENDA';
export const FINALIZAR_ENTREGA_ENCOMENDA = 'FINALIZAR_ENTREGA_ENCOMENDA';

export const LISTAR_FILTROS_AGENDAMENTO_VIAGEM = 'LISTAR_FILTROS_AGENDAMENTO_VIAGEM';
export const REMOVER_FILTRO_AGENDAMENTO_VIAGEM = 'REMOVER_FILTRO_AGENDAMENTO_VIAGEM';
export const ADICIONAR_FILTRO_AGENDAMENTO_VIAGEM = 'ADICIONAR_FILTRO_AGENDAMENTO_VIAGEM';
export const LIMPAR_FILTRO_AGENDAMENTO_VIAGEM = 'LIMPAR_FILTRO_AGENDAMENTO_VIAGEM';

export const CADASTRAR_CONFIGURACAO_PONTO = 'CADASTRAR_CONFIGURACAO_PONTO';
export const BUSCAR_CONFIGURACAO_PONTO = 'BUSCAR_CONFIGURACAO_PONTO';
export const LIMPAR_CONFIGURACAO_PONTO = 'LIMPAR_CONFIGURACAO_PONTO';
export const BUSCAR_OPCOES_FILTROS_ADESAO_PONTOS = 'BUSCAR_OPCOES_FILTROS_ADESAO_PONTOS';
export const SELECIONAR_CONFIGURACAO_PONTO = 'SELECIONAR_CONFIGURACAO_PONTO';
export const BUSCAR_CONFIGURACAO_PONTO_EMPRESA = 'BUSCAR_CONFIGURACAO_PONTO_EMPRESA';
export const LIMPAR_CONFIGURACAO_PONTO_EMPRESA = 'LIMPAR_CONFIGURACAO_PONTO_EMPRESA';
export const CADASTRAR_CONFIGURACAO_CONSUMO_PONTO = 'CADASTRAR_CONFIGURACAO_CONSUMO_PONTO';
export const BUSCAR_CLIENTES_EMPRESA = 'BUSCAR_CLIENTES_EMPRESA';
export const SELECIONAR_CLIENTE_PONTOS = 'SELECIONAR_CLIENTE_PONTOS';
export const AJUSTAR_PONTOS_CLIENTE = 'AJUSTAR_PONTOS_CLIENTE';
export const BUSCAR_VIAGENS_CLIENTE_PONTOS = 'BUSCAR_VIAGENS_CLIENTE_PONTOS';
export const LIMPAR_VIAGENS_CLIENTE_PONTOS = 'LIMPAR_VIAGENS_CLIENTE_PONTOS';
export const BUSCAR_EXTRATO_PONTOS_CLIENTE = 'BUSCAR_EXTRATO_PONTOS_CLIENTE';
export const LIMPAR_EXTRATO_PONTOS_CLIENTE = 'LIMPAR_EXTRATO_PONTOS_CLIENTE';

export const BUSCAR_AGENCIAS_EMPRESA = 'BUSCAR_AGENCIAS_EMPRESA';

export const SELECIONAR_TRECHO_PASSAGEIRO = 'SELECIONAR_TRECHO_PASSAGEIRO';
export const BUSCAR_TRECHOS_RESERVAS_ITINERARIO = 'BUSCAR_TRECHOS_RESERVAS_ITINERARIO';
export const LIMPAR_TRECHOS_RESERVAS_ITINERARIO = 'LIMPAR_TRECHOS_RESERVAS_ITINERARIO';

export const BUSCAR_CIDADES_TRECHOS = 'BUSCAR_CIDADES_TRECHOS';

export const BUSCAR_SE_USUARIO_BLOQUEADO_EDICAO_E_REIMPRESAO_CUPOM = 'BUSCAR_SE_USUARIO_BLOQUEADO_EDICAO_E_REIMPRESAO_CUPOM';

export const CADASTRAR_COMISSAO_REIMPRESSAO_RECIBO = 'CADASTRAR_COMISSAO_REIMPRESSAO_RECIBO';
export const HABILITADO_PAGAMENTO_TEF = 'HABILITADO_PAGAMENTO_TEF';
export const HABILITADO_PAGAMENTO_LINK = 'HABILITADO_PAGAMENTO_LINK';
export const HABILITADO_CIELO_ECOMMERCE = 'HABILITADO_CIELO_ECOMMERCE';
export const HABILITADO_SICOOB = 'HABILITADO_SICOOB';
export const HABILITADO_STONE_CONNECT = 'HABILITADO_STONE_CONNECT';
export const BUSCAR_TODOS_USUARIOS_RELATORIO = 'BUSCAR_TODOS_USUARIOS_RELATORIO';
export const LIMPAR_USUARIOS_RELATORIO = 'LIMPAR_USUARIOS_RELATORIO';
export const DOWNLOAD_PARTE_FECHAMENTO_CAIXA = 'DOWNLOAD_PARTE_FECHAMENTO_CAIXA';
export const DOWNLOAD_RELATORIO_COMPLETO_USUARIOS = 'DOWNLOAD_RELATORIO_COMPLETO_USUARIOS';

export const HABILITAR_AUTENTICACAO_DOIS_FATORES = 'HABILITAR_AUTENTICACAO_DOIS_FATORES';
export const RECUSAR_AUTENTICACAO_DOIS_FATORES = 'RECUSAR_AUTENTICACAO_DOIS_FATORES';
export const BUSCAR_ULTIMOS_HISTORICOS_PASSAGEIRO = 'BUSCAR_ULTIMOS_HISTORICOS_PASSAGEIRO';
export const LIMPAR_ULTIMOS_HISTORICOS_PASSAGEIRO = 'LIMPAR_ULTIMOS_HISTORICOS_PASSAGEIRO';
export const BUSCAR_HISTORICOS_RESERVAS = 'BUSCAR_HISTORICOS_RESERVAS';
export const LIMPAR_HISTORICOS_RESERVAS = 'LIMPAR_HISTORICOS_RESERVAS';
export const BUSCAR_CONFIG_GRATUIDADE_TIPO_PRECO = 'BUSCAR_CONFIG_GRATUIDADE_TIPO_PRECO';
export const SALVAR_CONFIG_GRATUIDADE_TIPO_PRECO = 'SALVAR_CONFIG_GRATUIDADE_TIPO_PRECO';
export const REMOVER_CONFIG_GRATUIDADE_TIPO_PRECO = 'REMOVER_CONFIG_GRATUIDADE_TIPO_PRECO';
export const BUSCAR_CONFIGURACAO_EMPRESA = 'BUSCAR_CONFIGURACAO_EMPRESA';
export const ATUALIZAR_CONFIGURACAO_EMPRESA = 'ATUALIZAR_CONFIGURACAO_EMPRESA';

export const LISTAR_PONTOS_EMBARQUE = 'LISTAR_PONTOS_EMBARQUE';
export const LISTAR_PONTOS_EMBARQUE_CIDADE = 'LISTAR_PONTOS_EMBARQUE_CIDADE';
export const LIMPAR_PONTOS_EMBARQUE_CIDADE = 'LIMPAR_PONTOS_EMBARQUE_CIDADE';
export const ADICIONAR_FILTRO_PONTO_EMBARQUE = 'ADICIONAR_FILTRO_PONTO_EMBARQUE';
export const REMOVER_FILTRO_PONTO_EMBARQUE = 'REMOVER_FILTRO_PONTO_EMBARQUE';
export const LIMPAR_FILTRO_PONTO_EMBARQUE = 'LIMPAR_FILTRO_PONTO_EMBARQUE';
export const BUSCAR_PONTOS_EMBARQUE_FILTRADO = 'BUSCAR_PONTOS_EMBARQUE_FILTRADO';

export const VENDA_SALVA_OFFLINE = 'VENDA_SALVA_OFFLINE';
export const VENDAS_OFFLINE_ENVIADAS = 'VENDAS_OFFLINE_ENVIADAS';
export const VENDAS_URBANAS_OFFLINE_ENVIADAS = 'VENDAS_URBANAS_OFFLINE_ENVIADAS';

export const BUSCAR_VENDAS_URBANAS = 'BUSCAR_VENDAS_URBANAS';
export const BUSCAR_VENDA_URBANA = 'BUSCAR_VENDA_URBANA';
export const LIMPAR_VENDA_URBANA = 'LIMPAR_VENDA_URBANA';
export const BUSCAR_ITINERARIOS_ABERTOS_VENDA_URBANA = 'BUSCAR_ITINERARIOS_ABERTOS_VENDA_URBANA';

export const ENCOMENDAS_AVULSAS_OFFLINE_ENVIADAS = 'ENCOMENDAS_AVULSAS_OFFLINE_ENVIADAS';
export const BUSCAR_ENCOMENDAS_AVULSAS = 'BUSCAR_ENCOMENDAS_AVULSAS';
export const BUSCAR_ENCOMENDA_AVULSA = 'BUSCAR_ENCOMENDA_AVULSA';
export const LIMPAR_ENCOMENDA_AVULSA = 'LIMPAR_ENCOMENDA_AVULSA';
export const BUSCAR_ITINERARIOS_ABERTOS_ENCOMENDA_AVULSA = 'BUSCAR_ITINERARIOS_ABERTOS_ENCOMENDA_AVULSA';

